import { Component, OnInit, Input } from "@angular/core";
import { DashboardService } from "../../dashboard.service";

@Component({
	selector: "rs-empty-icon-prompt",
	templateUrl: "./empty-icon-prompt.component.html",
	styleUrls: ["./empty-icon-prompt.component.scss"],
})
export class EmptyIconPromptComponent implements OnInit {
	@Input() displayCode;
	@Input() dashboard;
	constructor(private DashboardService: DashboardService) {}

	ngOnInit() {}
	public editProperties() {
		this.DashboardService.properties.next({
			status: false,
			id: this.dashboard.id,
		});
	}
	public createNewDashboard() {
		this.DashboardService.createGroupDashboard.next(true);
	}
	public customize() {
		this.DashboardService.customized = true;
	}
}
